import { ComponentProps, JSXElementConstructor } from 'react';
import { registerModals } from '@betty/navigation';
import { DetailsAttestationScreen } from '../screens';

const modals = {
  DetailsAttestation: DetailsAttestationScreen,
};

registerModals('detailsAttestation', modals);

declare global {
  interface RegisteredModals {
    detailsAttestation: {
      [K in keyof typeof modals]: JSXElementConstructor<
        ComponentProps<(typeof modals)[K]>
      >;
    };
  }
}
